import { lazy } from 'react';
import { Navigate, Router } from 'react-router-dom';

// project imports
import Loadable from 'qubCommon/Other/Loadable';
import MinimalLayout from 'layout/MinimalLayout';
import PublicRoute from './PublicRoute';
import { PublicClubView, PublicClubsMapView, PublicSingleClubMapView } from 'views/public/Clubs';
import { PublicAthletesView } from 'views/public/Athletes';
import { PublicOffialsView } from 'views/public/Officials';
import { PublicSingleSiteMapView, PublicSiteDetailsView, PublicSitesView } from 'views/public/Sites';

// login option 3 routing
const AuthLogin3 = Loadable(lazy(() => import('views/authentication/authentication3/Login3')));
// const AuthRegister3 = Loadable(lazy(() => import('views/authentication/authentication3/Register3')));
const ResetPassword = Loadable(lazy(() => import('views/authentication/forgotPassword')));
const UserInvitation = Loadable(lazy(() => import('views/authentication/userInvitation')));
const PaymentSubmittion = Loadable(lazy(() => import('views/application/Payments/Submittion')));
const TermsOfUse = Loadable(lazy(() => import('views/TermsOfUse')));
const PaymentResultPage = Loadable(lazy(() => import('views/application/Payments/Submittion/paymentMethod/byCard/form/resultPage')));
const CompetitionsCalendar = Loadable(lazy(() => import('views/public/Competitions').then((module) => ({ default: module.Calendar }))));
const CompetitionsMapView = Loadable(lazy(() => import('views/public/Competitions').then((module) => ({ default: module.MapView }))));
const CompetitionDetails = Loadable(lazy(() => import('views/public/Competitions').then((module) => ({ default: module.Details }))));
const PublicClubDetail = Loadable(lazy(() => import('views/public/Clubs/Manage/ClubDetail')));
const PublicClubManage = (Loadable(lazy(() => import('views/public/Clubs/Manage'))));

const getLoginRedirectPath = () => `/login?navUrl=${encodeURIComponent(`${window.location.pathname}${window.location.search}`)}`;
// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = () => {
    return [
        {
            path: '/',
            element: <MinimalLayout />,
            children: [
                {
                    path: '',
                    element: <Navigate to="/login" />
                },
                {
                    path: 'api/payment/success',
                    element: <PaymentResultPage />
                },
                {
                    path: 'api/payment/fail',
                    element: <PaymentResultPage />
                },
                {
                    path: '/login',
                    element: <AuthLogin3 />
                },
                /* {
                path: '/register',
                element: <AuthRegister3 />
            }, */
                {
                    path: '/reset/:token',
                    element: <ResetPassword />
                },
                {
                    path: '/invite',
                    element: <UserInvitation />
                },
                {
                    path: '/invite',
                    element: <UserInvitation />
                },
                {
                    path: 'TermsOfUse',
                    element: <TermsOfUse />
                },
                {
                    path: '/payment/:token',
                    element: <PaymentSubmittion />
                }
            ]
        },
        {
            path: 'public',
            element: <PublicRoute />,
            children: [
                {
                    path: '',
                    element: <Navigate to="calendar" />
                },
                {
                    path: 'calendar',
                    element: <CompetitionsCalendar />
                },
                {
                    path: 'competitions-map',
                    element: <CompetitionsMapView />
                },
                {
                    path: 'competition',
                    element: <CompetitionDetails />
                },
                {
                    path: 'athletes',
                    element: <PublicAthletesView />
                },
                {
                    path: 'officials',
                    element: <PublicOffialsView />
                },
                {
                    path: 'clubs',
                    element: <PublicClubView />
                },
                {
                    path: 'sites',
                    element: <PublicSitesView />
                },
                {
                    path: 'sites/map/:id',
                    element: <PublicSingleSiteMapView />
                },
                {
                    path: 'sites/:id',
                    element: <PublicSiteDetailsView />
                },
                {
                    path: 'clubs/map',
                    element: <PublicClubsMapView />
                },
                {
                    path: 'clubs/map/:id',
                    element: <PublicSingleClubMapView />
                },
                {
                    path: 'clubs/manage/:id',
                    element: <PublicClubManage />,
                    children: [
                        {
                            path: 'details',
                            element: <PublicClubDetail />
                        }
                    ]
                }
            ]
        },
        {
            path: '*',
            element: <Navigate to={getLoginRedirectPath()} />
        }
    ];
};
export default AuthenticationRoutes;
